// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft, original } from "immer";

export type CommonActionsState = {
    [key: string]: any;
};

const initialCommonActionsState: CommonActionsState = {};

const commonActions = createTypedReducerWithImmer(initialCommonActionsState, {
    "commonActionSetter/SetAction": (draft: Draft<CommonActionsState>, action: { payload: any }) => {
        draft[action.payload.name] = action.payload.value!;
    },
});

(reducers as any).commonActions = commonActions;

type xCommonActionsReducers = {
    commonActions: typeof commonActions;
};

export type xCommonActions = Parameters<xCommonActionsReducers[keyof xCommonActionsReducers]>[1] | AnyAction;
